import { ChevronRight } from "lucide-react"

import { useLocalHref, useUi } from "@/core/i18n/locale-context"

interface BreadcrumbProps {
  /** Last item is the current page and has no href. */
  items: { label: string; href?: string }[]
}

export const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const ui = useUi()
  const localHref = useLocalHref()
  return (
    <nav aria-label={ui.breadcrumb} className="px-band pt-3 md:pt-4">
      <ol className="text-muted-foreground flex flex-wrap items-center gap-1.5 text-sm">
        {items.map(({ label, href }, i) => {
          const last = i === items.length - 1
          return (
            <li key={href ?? label} className="flex items-center gap-1.5">
              {last || !href ? (
                <b
                  aria-current={last ? "page" : undefined}
                  className="text-foreground font-semibold"
                >
                  {label}
                </b>
              ) : (
                <a
                  href={localHref(href)}
                  className="hover:text-foreground focus-visible:ring-ring inline-flex min-h-11 items-center rounded-sm outline-none focus-visible:ring-2 md:min-h-0"
                >
                  {label}
                </a>
              )}
              {!last && <ChevronRight className="size-3.5" aria-hidden="true" />}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
